import { render, staticRenderFns } from "./StatTable.vue?vue&type=template&id=2ac5b528&"
import script from "./StatTable.vue?vue&type=script&lang=js&"
export * from "./StatTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports